import {PictureTextLinkCols} from './App/Components/PrictureTextLinkCols.js';

document.addEventListener('DOMContentLoaded', () => {
    const picTxtLinkCols = new PictureTextLinkCols();
    picTxtLinkCols.init();
});
